export default "__VITE_ASSET___EAunF$o__"